import { useThemeStore, withErrorBoundary } from '@navi-app/utils';
import { TileLayer } from 'react-leaflet';
import { useShallow } from 'zustand/react/shallow';
import {
  CARTO_ATTRIBUTION,
  OSM_ATTRIBUTION,
  TILES,
  getCartoTileUrl,
} from './constants/map-tiles';
import { MapAzureLiveTraffic } from './map-azure-live-traffic';

type TMapTilesLayer = {
  nexisUrl?: string;
};

const MapTilesLayer = ({ nexisUrl }: TMapTilesLayer) => {
  const { mapTile } = useThemeStore(
    useShallow((state) => ({
      mapTile: state.mapTile,
    }))
  );

  const renderTileLayer = () => {
    switch (mapTile) {
      case TILES.OSM_LIGHT:
        return (
          <TileLayer url={getCartoTileUrl()} attribution={CARTO_ATTRIBUTION} />
        );
      case TILES.OSM_STANDARD:
        return (
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution={OSM_ATTRIBUTION}
          />
        );
      case TILES.LIVE_TRAFFIC_AZURE: {
        return (
          <>
            <MapAzureLiveTraffic nexisUrl={nexisUrl} />
            <TileLayer
              url={getCartoTileUrl()}
              attribution={CARTO_ATTRIBUTION}
            />
          </>
        );
      }
      default:
        return (
          <TileLayer url={getCartoTileUrl()} attribution={CARTO_ATTRIBUTION} />
        );
    }
  };

  return renderTileLayer();
};

export default withErrorBoundary(MapTilesLayer);
